export const ORG_TYPES = ["university", "school", "association", "municipality", "other"] as const;
export type OrgType = (typeof ORG_TYPES)[number];
export type OrgStatus = "active" | "suspended";

export type Org = {
  id: number;
  name: string;
  type: string;
  status: OrgStatus | null;
  contract_starts_on: string | null;
  contract_ends_on: string | null;
  learner_cap: number | null;
  learner_count?: number;
};

export type OrgInput = {
  name: string;
  type: string;
  status: OrgStatus;
  contract_starts_on: string | null;
  contract_ends_on: string | null;
  learner_cap: number | null;
};

export type Invitation = { token?: string; path?: string };

/** JST の今日（YYYY-MM-DD） */
export function todayJst(): string {
  return new Date(Date.now() + 9 * 3600_000).toISOString().slice(0, 10);
}

/** 契約の判定（requests.md）：停止、または今日が開始日より前・終了日より後なら契約外。終了日の当日は有効 */
export function isInContract(o: Pick<Org, "status" | "contract_starts_on" | "contract_ends_on">): boolean {
  if (o.status === "suspended") return false;
  const today = todayJst();
  if (o.contract_starts_on && today < o.contract_starts_on) return false;
  if (o.contract_ends_on && today > o.contract_ends_on) return false;
  return true;
}
